<h1 mat-dialog-title>Descripción</h1>
<div mat-dialog-content>{{data}}</div>
<div mat-dialog-actions>
    <button mat-button mat-dialog-close>Cerrar</button>
</div>